import { buffer, Subject } from 'rxjs';
import invariant from 'fbjs/lib/invariant.js';
import interpolate from '#/lib/interpolate.js';
import Metric from '#/entities/metrics/metric.js';

export class MetricsCollector {
  #enabled = false;
  #metrics;
  #bufferTrigger = new Subject();

  #timoutId = null;

  constructor(dependencies) {
    const { configProvider, mns, store } = dependencies;

    invariant(configProvider, 'Missing required dependency');
    invariant(mns, 'Missing required dependency');
    invariant(store, 'Missing required dependency');

    const self = this;
    let transport = (metric) => {
      console.warn('no transport for metric', metric);
    }

    configProvider.config.subscribe((config) => {
      self.#enabled = config.metrics_enabled;
    });

    /* So sad, but there are no way to get video config at the moment */
    store.listener.startListening({
      type: 'INTERACTIVE/START',//actions.interactiveStart,
      effect(action) {
        transport = (metric) => {
          const topic = interpolate(action.payload.config.metric.publish, {
            tracking_event_type: metric.name,
            entity_id: metric.entityId,
          });
          mns.publish(topic, metric.data, 0);
        };
      }
    });

    this.#metrics = new Subject();
    const buffered = this.#metrics.pipe(
      buffer(this.#bufferTrigger),
    );

    buffered.subscribe((metrics) => {
      metrics.forEach((metric) => {
        transport(metric);
      });
    });
  }

  push(metric) {
    invariant(metric, 'Missing required metric');
    invariant(metric instanceof Metric, 'Unexpected metric type');

    if (!this.#enabled) {
      return;
    }
    this.#metrics.next(metric);
    const delay = 10_000 + Math.random() * 20_000;
    setTimeout(() => {
      this.#bufferTrigger.next();
    }, delay);
  }

  flush(){
    clearTimeout(this.#timoutId);
    this.#bufferTrigger.next();
  }
}
